module.exports = __webpack_public_path__ + "media/components/incentive/static/surf-icon-000b14682aeef645dbadabd28f7067ee.svg";